import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';

// LocateButton is the location pin next to a device's name. With onLocate it
// shows the device on its room's floor plan; without, it is just the icon.
const LocateButton = ({ device, onLocate, className = '' }) => {
        if (!onLocate) {
                return <FontAwesomeIcon icon={faLocationDot} className={`text-brand flex-shrink-0 ${className}`} />;
        }

        const placed = device.plan_x != null && device.plan_y != null;
        return (
                <button
                        type="button"
                        data-testid="device-locate"
                        title={placed ? 'Show on floor plan' : 'Not placed on floor plan'}
                        aria-label={`Show ${device.name} on floor plan`}
                        onClick={(e) => {
                                e.stopPropagation();
                                onLocate(device.id);
                        }}
                        className={`flex-shrink-0 -m-1.5 p-1.5 rounded-full hover:bg-brand/10 transition-colors ${placed ? 'text-brand' : 'text-gray-300 hover:text-brand'} ${className}`}
                >
                        <FontAwesomeIcon icon={faLocationDot} />
                </button>
        );
};

export default LocateButton;
